document.addEventListener('DOMContentLoaded', function() {
    // Using jQuery for Shopify compatibility
    if (typeof jQuery !== 'undefined') {
        (function($) {
            $('.elementor-search-form__toggle').on('click', function() {
                $('.elementor-search-form__container').addClass('active');
            });
            $('.dialog-lightbox-close-button').on('click', function() {
                $('.elementor-search-form__container').removeClass('active');
            });
            $(document).on('keydown', function(e) {
                if (e.key === 'Escape') {
                    $('.elementor-search-form__container').removeClass('active');
                }
            });
        })(jQuery);
    }
});

jQuery(function($){
  $("#elementor-menu-cart__toggle_button").on('click', function(event){
    // event.preventDefault();
    $(".elementor-element.toggle-icon--cart-solid").addClass("elementor-menu-cart--shown");
  })
  $(".elementor-menu-cart__close-button").on('click', function(event){
    // event.preventDefault();
    $(".elementor-element.toggle-icon--cart-solid").removeClass("elementor-menu-cart--shown");
  })
  
  // $('.quantity__input').on('click', function(event){
  //     console.log('clicked');
  //   if($(this).val() <= 1){
  //       $(this).siblings('button[name="minus"]').prop('disabled', true).css({'visibility': 'hidden'});
  //       // $(this).siblings('button[name="minus"]').css({'visibility': 'hidden'})
  //     }else{
  //       $(this).siblings('button[name="minus"]').prop('disabled', false).css({'visibility': 'visible'});
  //     }
  // })
  
  // $('.quantity__input').each(function(index, element){
  //   console.log({element});
  //   if($(this).val() <= 1){
  //     console.log('value is minimum');
  //     $(this).siblings('button[name="minus"]').prop('disabled', true).css({'visibility': 'hidden'});
  //     // $(this).siblings('button[name="minus"]').css({'visibility': 'hidden'})
  //   }else{
  //     $(this).siblings('button[name="minus"]').prop('disabled', false).css({'visibility': 'visible'});
  //   }
  // })

  // Tab switching for account page tabs
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-nav button');
    const panels = document.querySelectorAll('.tab-panel');
    const logoutTab = document.getElementById('logout-tab');

    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        if (tab === logoutTab) {
          // Redirect to logout URL
          window.location.href = "{{ routes.account_logout_url }}";
          return;
        }

        // Remove active class and aria-selected from all tabs
        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });

        // Hide all panels
        panels.forEach(panel => {
          panel.classList.remove('active');
        });

        // Activate clicked tab and corresponding panel
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        const panelId = tab.getAttribute('aria-controls');
        if (panelId) {
          const panel = document.getElementById(panelId);
          if (panel) {
            panel.classList.add('active');
          }
        }
      });
    });
  });
})

// cart.js code for reference
// this.updateMainCartFooterTotalValue().catch((e) => {
//   console.error('Failed to update main cart footer total value:', e);
// });

// updateMainCartFooterTotalValue() {
//   return fetch(`${routes.cart_url}?section_id=main-cart-footer`)
//     .then((response) => response.text())
//     .then((responseText) => {
//       const html = new DOMParser().parseFromString(responseText, 'text/html');
//       const newTotalValue = html.querySelector('#main-cart-footer .totals__total-value');
//       const currentTotalValue = document.querySelector('#main-cart-footer .totals__total-value');
//       if (newTotalValue && currentTotalValue) {
//         currentTotalValue.innerHTML = newTotalValue.innerHTML;
//       }
//     });
// }



jQuery(document).ready(function($) {
  $('.elementor-menu-toggle').on('click', function() {
    const $menu = $('.elementor-nav-menu--dropdown.elementor-nav-menu__container');
    const $openIcon = $('.elementor-menu-toggle__icon--open.eicon-menu-bar');
    const $closedIcon = $('.elementor-menu-toggle__icon--close.eicon-close');
    
    const isOpen = $menu.hasClass('menu-open');
    const screenHeight = $(window).height();
    const screenWidth = $(window).width();
    
    if (isOpen) {
      // Show open icon, hide close icon
      $openIcon.css('display', 'block');
      $closedIcon.css('display', 'none');

      // Close menu
      $menu.removeClass('menu-open').css({
        'max-height': '0',
        'transform': 'scaleY(0)'
      });

    } else {
      // Decide left offset based on screen width
      const leftValue = screenWidth <= 767 ? '-84vw' : '-1.3vw';

      // Open menu
      $menu.addClass('menu-open').css({
        'max-height': screenHeight + 'px',
        'width': '100vw',
        'left': leftValue,
        'transform': 'scaleY(1)',
        'top': '30px'
      });

      // Show close icon, hide open icon
      $closedIcon.css('display', 'block');
      $openIcon.css('display', 'none');
    }
  });
});

// jQuery('p:has(a[href="https://globosoftware.net"])').remove()
const observer = new MutationObserver(function (mutationsList, observer) {
const $target = jQuery('p:has(a[href="https://globosoftware.net"])');
  if ($target.length) {
    $target.remove();
    observer.disconnect(); // stop observing once removed
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});